import { render } from "./BookSuccession.vue?vue&type=template&id=5d9bb917&scoped=true"
import script from "./BookSuccession.vue?vue&type=script&lang=js"
export * from "./BookSuccession.vue?vue&type=script&lang=js"

import "./BookSuccession.vue?vue&type=style&index=0&id=5d9bb917&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d9bb917"]])

export default __exports__